<template>
  <div class="aftersale-table">
    <el-table :data="data" border style="width: 100%" max-height="300" @selection-change="selectAftersale"
      ref="aftersaleTable">
      <el-table-column type="selection" width="55" fixed="left">
      </el-table-column>
      <el-table-column type="index" label="序号" width="40"></el-table-column>
      <el-table-column prop="created_at" label="日期" width="120">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.created_at }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="as_number" label="服务编号" width="130">
        <template slot-scope="scope">
          <span class="blue" @click="getDetailTable(scope.row)">{{
            scope.row.as_number
            }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="order_number" label="订单号" width="120">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.order_number }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="user_name" label="客户姓名">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            <MaskViewVue type="maskName" :maskVal="scope.row.user_name" :customParams="{
              expand: JSON.stringify({
                xAPIVersion: 'V1.0',
                xSystemID: 'diablo',
              }),
            }" />
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="applied_num" label="申请数量" width="65">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.applied_num }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="applied_price" label="申请金额">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            <div v-if="scope.row.as_typeName === '维修'">-</div>
            <div v-else>{{ scope.row.applied_price }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="received_num" label="收货数量" width="65">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.received_num }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="accepted_num" label="确认数量" width="65">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.accepted_num }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="accepted_price" label="确认金额">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            <div v-if="scope.row.as_typeName === '维修'">-</div>
            <div v-else>{{ scope.row.accepted_price }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="returned_num" label="出库数量" width="65">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.returned_num }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="express" label="物流承运商"> </el-table-column>
      <el-table-column prop="as_statusName" label="售后状态">
        <template slot-scope="scope">
          <div @click="seeColseReasonHandler(scope.row)" :class="{ close: scope.row.as_statusName === '关闭' }">
            {{ scope.row.as_statusName }}
            <span v-if="scope.row.as_statusName === '关闭'" class="el-icon-warning" :style="{ color: '#236bdc' }"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="as_typeName" label="售后类型">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.as_typeName }}
          </div>
        </template>
      </el-table-column>
      <!-- 新逻辑 2021.07.26 平台 工厂 直发 都显示该字段 -->
      <el-table-column prop="as_status_source" label="处理方式" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.as_status_source == '1'">店铺处理</span>
          <span v-if="scope.row.as_status_source == '2'">客服处理</span>
        </template>
      </el-table-column>
      <!-- 提货物流状态 2022-10-20新增 -->
      <el-table-column prop="in_box_status_msg" label="提货物流状态" v-if="isZhifaOrFactory">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.in_box_status_msg }}
          </div>
        </template>
      </el-table-column>
      <!-- 送货物流状态 2022-10-20新增 -->
      <el-table-column prop="out_box_status_msg" label="送货物流状态" v-if="isZhifaOrFactory">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            {{ scope.row.out_box_status_msg }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="user_mobile" label="客户电话" width="100">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            <MaskViewVue type="maskPhone" :maskVal="scope.row.user_mobile" :customParams="{
              expand: JSON.stringify({
                xAPIVersion: 'V1.0',
                xSystemID: 'diablo',
              }),
            }" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="user_address" label="客户地址" width="300">
        <template slot-scope="scope">
          <div @click="getDetailTable(scope.row)">
            <MaskViewVue type="maskAddress" :maskVal="scope.row.user_address" :customParams="{
              expand: JSON.stringify({
                xAPIVersion: 'V1.0',
                xSystemID: 'diablo',
              }),
            }" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="abnormal" label="异常" width="60" v-if="!isZhifaOrFactory">
        <template slot-scope="scope">
          <i class="el-icon-warning" v-show="scope.row.is_abnormal === '1'"></i>
        </template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="140">
        <template slot-scope="scope">
          <el-button size="small" :style="{ color: '#236bdc' }" @click="getBoxData(scope.row)">查看</el-button>
          <el-button size="small" :style="{ color: '#236bdc' }" @click="changeBoxData(scope.row)">新建工单</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="closeReasonDialog" title="关闭原因" :append-to-body="true" width="400px">
      <span slot="title" :style="{ color: '#fff' }">服务编号：{{ close_as_number }}</span>
      <div class="close-reason">
        <table border="1" cellspacing="0">
          <tr>
            <th>关闭原因</th>
            <td>
              {{ closeReason }}
            </td>
          </tr>
        </table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getCloseReason } from "@/models/aftersaleModel";
// import Countdown from '@/utils/time'

import { MaskViewVue } from "ruigu-utils";
export default {
  props: ["data", "statusActive"],
  components: {
    MaskViewVue
  },
  data() {
    return {
      closeReasonDialog: false,
      closeReason: "",
      close_as_number: "",
      isZhifaOrFactory:
        localStorage.getItem("shop_type") === "1" ||
        localStorage.getItem("shop_type") === "2"
    };
  },
  mounted() { },
  methods: {
    selectAftersale(val) {
      this.$emit("getSelectSaleData", val);
    },
    //  关闭原因
    seeColseReasonHandler(row) {
      let vm = this;
      // console.log('close1', row)
      if (row.as_statusName === "关闭") {
        // console.log('close2', vm.closeReasonDialog)
        getCloseReason({ id: row.id }).then(res => {
          if (res.code === 200) {
            vm.closeReason = res.data.reason;
            vm.close_as_number = row.as_number;
            vm.closeReasonDialog = true;
          }
          // console.log('close3', res)
        });
      } else {
        this.$refs.aftersaleTable.clearSelection();
        this.$refs.aftersaleTable.toggleRowSelection(row);
      }
    },
    getDetailTable(data) {
      this.$refs.aftersaleTable.clearSelection();
      this.$refs.aftersaleTable.toggleRowSelection(data);
      if (this.isZhifaOrFactory) {
        this.$emit("getTrackNo", data);
      }
    },
    getBoxData(row) {
      this.$emit("getBoxData", row);
    },
    changeBoxData(row) {
      this.$emit("changeBoxData", row);
    },
    editOrder() { }
  }
};
</script>
<style lang="scss">
.aftersale-table {
  .cell div {
    width: 100%;
    height: 25px;
  }

  .el-icon-warning {
    color: red;
    // cursor: pointer;
  }

  .blue {
    color: #236bdc;
    text-decoration: underline;
    cursor: pointer;
  }

  .detailTable {
    // line-height: 0;
    cursor: pointer;
    text-decoration: underline;
    color: #236bdc;
  }

  .detailTable:hover {
    color: #ff6224;
  }
}

.close {
  color: #236bdc;
  cursor: pointer;
}

.close-reason {
  table {
    width: 100%;
    border-color: rgb(243, 243, 243);

    th {
      text-align: center;
      padding: 15px;
      width: 80px;
      font-size: 14px;
      font-weight: 400;
      background-color: rgb(243, 243, 243);
    }

    td {
      font-size: 14px;
      padding: 15px;
      text-align: left;
      word-break: break-all;
    }
  }
}
</style>
<style lang="scss" scope>
// .close-reason{
//   table{
//     // border: 1px solid;
//     // padding: 10px;
//     width: 100%;
//     border-color: rgb(243, 243, 243)
//     th{
//       text-align: center;
//       padding: 15px;
//       max-width: 100px;
//       font-size: 14px;
//       font-weight: 400;
//       background-color: rgb(243, 243, 243);
//       // display:inline-block;
//       // border: 1px;
//     }
//     td{
//       // display:inline-block;
//       font-size: 14px;
//       padding: 15px;
//       text-align: left;
//       // width: 100%;
//     }
//   }
//   // box-sizing: border-box;
//   // font-size: 14px;
//   // border: 1px solid rgb(243, 243, 243);
//   .close-reason-title{
//     display:inline-block;
//     box-sizing: border-box;
//     padding: 15px;
//     background-color: rgb(243, 243, 243);
//     text-align: center;
//     max-width: 100px;
//     border-right:1px solid rgb(243, 243, 243);
//   }
//   .close-reason-text{
//     display:inline-block;
//     box-sizing: border-box;
//     padding: 15px;
//     text-align: left;
//   }
// }</style>



// WEBPACK FOOTER //
// src/components/bigAftersale/aftersale-table.vue